type Point = { x: number; y: number };
export type Points = Point[];

export const drawSmoothCurve = (context: CanvasRenderingContext2D, points: Points) => {
  const firstPoint = points[0];
  const lastPoint = points[points.length - 1];

  if (!firstPoint || !lastPoint) {
    throw new Error('No points provided to drawSmoothCurve');
  }

  context.beginPath();
  context.moveTo(firstPoint.x, firstPoint.y);

  for (let i = 1; i < points.length - 1; i++) {
    const currentPoint = points[i];
    const nextPoint = points[i + 1];
    if (!currentPoint) {
      throw new Error(`Missing point at index ${i} in points array`);
    }
    if (!nextPoint) {
      throw new Error(`Missing point at index ${i + 1} in points array`);
    }
    const xc = (currentPoint.x + nextPoint.x) / 2;
    const yc = (currentPoint.y + nextPoint.y) / 2;
    context.quadraticCurveTo(currentPoint.x, currentPoint.y, xc, yc);
  }

  // Connect the last two points with a straight line
  context.lineTo(lastPoint.x, lastPoint.y);
  context.stroke();
};
